export const getTimeZoneLabel = (time: Date): string => {
  const timeZoneOffset = time.getTimezoneOffset() / 60
  return timeZoneOffset < 0 ? `UTC+${Math.abs(timeZoneOffset)}` : `UTC-${Math.abs(timeZoneOffset)}`
}

export const floorToMinutes = (date: Date, step: number = 15): Date => {
  const minutes = date.getUTCMinutes()
  const flooredMinutes = Math.floor(minutes / step) * step
  const floored = new Date(date)
  floored.setUTCMinutes(flooredMinutes, 0, 0)
  return floored
}
